// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__15tPf","line":"Divider_line__1Bw4N"};